import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Newsletter from "@/components/Newsletter";
import api from "@/lib/api";

export default function Article() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/posts/${slug}`).then((res) => setPost(res.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="grain relative min-h-screen">
        <Navbar />
        <div className="pt-40 pb-24 text-center px-6">
          <h1 className="font-display font-black uppercase text-4xl">Article not found</h1>
          <button data-testid="article-back" onClick={() => navigate("/blog")} className="mt-8 bg-primary text-primary-foreground font-display font-bold uppercase px-6 py-3">
            Back to Journal
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  if (!post) {
    return (
      <div className="grain relative min-h-screen">
        <Navbar />
        <p className="pt-40 text-center font-mono-accent text-sm text-muted-foreground">Loading...</p>
      </div>
    );
  }

  return (
    <div className="grain relative min-h-screen">
      <Navbar />
      <main className="pt-32 pb-24">
        <article className="max-w-3xl mx-auto px-4 sm:px-6">
          <Link data-testid="article-back-link" to="/blog" className="inline-flex items-center gap-2 font-mono-accent text-xs uppercase tracking-[0.2em] text-muted-foreground hover:text-primary transition-colors mb-10">
            <ArrowLeft size={14} /> Back to Journal
          </Link>

          <div className="flex items-center gap-3 font-mono-accent text-[11px] uppercase tracking-[0.15em] text-primary mb-5">
            <span>{post.category}</span>
            <span className="text-muted-foreground">— {post.read_time}</span>
          </div>

          <h1 data-testid="article-title" className="font-display font-black uppercase tracking-tighter leading-[0.95] text-4xl sm:text-5xl lg:text-6xl mb-10">
            {post.title}
          </h1>

          <div className="aspect-[16/9] overflow-hidden border border-border mb-12">
            <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
          </div>

          <div data-testid="article-content" className="space-y-6 text-lg leading-relaxed text-foreground/90">
            {post.content.split("\n\n").map((para, i) => (
              <p key={i} className={i === 0 ? "drop-cap" : ""}>{para}</p>
            ))}
          </div>
        </article>
      </main>
      <Newsletter />
      <Footer />
    </div>
  );
}
